import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-cream-100" data-id="element-157">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-158">
        <FadeIn data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-teal-900 mb-8 text-center" data-id="element-160">
            El problema no es tu edad, ni que te falte ejercicio.
          </h2>
        </FadeIn>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-cream-300" data-id="element-161">
          <FadeIn delay={0.1} data-id="element-162">
            <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-163">
              El problema es que los estiramientos tradicionales están estirando
              un nervio que ya está inflamado y bajo presión.{' '}
              <strong className="text-coral-600 font-semibold" data-id="element-164">
                Es como intentar jalar una cuerda que está a punto de romperse.
              </strong>
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-165">
            <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-166">
              Para las mujeres de 35+, la carga del hogar, el trabajo y el
              estrés diario se acumula en la base de la espalda.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-167">
            <div className="bg-coral-50 border-l-4 border-coral p-6 rounded-r-lg" data-id="element-168">
              <p className="text-lg text-gray-800 font-medium italic" data-id="element-169">
                Si no creas espacio para que el nervio "respire", el dolor
                volverá cada vez que te agaches a recoger algo o pases más de 20
                minutos sentada.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}